var map = {
	"./CatalogCarousel/CatalogCarousel.vue": [
		1354,
		166
	],
	"./CatalogCarousel/CatalogItem.vue": [
		1347,
		245
	],
	"./MarketingCards.vue": [
		375
	],
	"./ProductCarousel/CarouselProductItem.vue": [
		1348,
		246
	],
	"./ProductCarousel/ProductCarousel.vue": [
		1355,
		6,
		107
	],
	"./ReorderHighlight/ReorderHighlight.vue": [
		1356,
		170
	],
	"./VoucherCarousel/VoucherCardItem.vue": [
		470
	],
	"./VoucherCarousel/VoucherCarousel.vue": [
		465
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1324;
module.exports = webpackAsyncContext;